export default __webpack_public_path__ + "static/media/3.780855d2.jpg";